import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { HelpCircle, X } from 'lucide-react';
import { safeHtml } from '@/lib/sanitize';

export const HelpButton = ({ title, content, size = 'sm' }) => {
  const [open, setOpen] = useState(false);
  
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button 
          variant="ghost" 
          size={size}
          className="text-slate-500 hover:text-slate-700 hover:bg-slate-100"
          data-testid="help-button"
        >
          <HelpCircle className="w-4 h-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-white border-slate-200 text-slate-900 max-w-lg shadow-xl">
        <DialogHeader>
          <DialogTitle className="text-xl flex items-center gap-2 text-slate-900">
            <HelpCircle className="w-5 h-5 text-blue-600" />
            {title}
          </DialogTitle>
        </DialogHeader>
        <div 
          className="text-slate-600 text-sm leading-relaxed help-content"
          dangerouslySetInnerHTML={safeHtml(content)}
        />
        <style>{`
          .help-content ul {
            list-style: disc;
            margin-left: 1.5rem;
            margin-top: 0.5rem;
          }
          .help-content li {
            margin-bottom: 0.25rem;
          }
          .help-content p {
            margin-bottom: 0.75rem;
          }
          .help-content strong {
            color: #1e293b;
          }
          .help-content code {
            background: rgba(59, 130, 246, 0.1);
            padding: 0.125rem 0.375rem;
            border-radius: 0.25rem;
            font-size: 0.875rem;
            color: #2563eb;
          }
        `}</style>
      </DialogContent>
    </Dialog>
  );
};

// Tooltip-style help for inline use
export const HelpTooltip = ({ content }) => {
  return (
    <div className="group relative inline-block">
      <HelpCircle className="w-4 h-4 text-slate-400 hover:text-slate-600 cursor-help" />
      <div className="invisible group-hover:visible absolute z-50 w-64 p-3 bg-white border border-slate-200 rounded-lg shadow-xl text-sm text-slate-600 bottom-full left-1/2 -translate-x-1/2 mb-2">
        {content}
        <div className="absolute top-full left-1/2 -translate-x-1/2 border-8 border-transparent border-t-white" />
      </div>
    </div>
  );
};

export default HelpButton;
